import { animate, style, transition, trigger } from '@angular/animations';

export const fadeCollapseAnimation = trigger('fadeCollapse', [
  transition(':enter', [
    style({ opacity: 0, height: 0, transform: 'scaleY(0.95)' }),
    animate('180ms ease-out', style({ opacity: 1, height: '*', transform: 'scaleY(1)' }))
  ]),
  transition(':leave', [
    style({ opacity: 1, height: '*', transform: 'scaleY(1)' }),
    animate('160ms ease-in', style({ opacity: 0, height: 0, transform: 'scaleY(0.95)' }))
  ])
]);